import React, { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { member } from '../../../../../api';
import UserContext from '../../../../UserContext';

import { DocumentPortal } from './DocumentPortal';
import { MemberDocumentDB } from 'api/members/document';
import { ForbiddenException } from 'api/exceptions/ForbiddenException';
import { UnauthorizedException } from 'api/exceptions/UnauthorizedException';

interface Props {
	uid: string;
	documentId: string;
}

export const ViewDocument = (props: Props) => {
	const { uid, documentId } = props;
	const { jwt } = useContext(UserContext);

	const [data, setData] = useState<MemberDocumentDB>();

	useEffect(() => {
		const getContents = async () => {
			try {
				const response = await member.document.get(jwt, uid, documentId);
				setData(response);
			} catch (error) {
				if (error instanceof ForbiddenException) {
					toast.error(error.message || 'You are not authorized to view this document');
				} else if (error instanceof UnauthorizedException) {
					toast.error('Your session has expired. Please log in again.');
				} else {
					toast.error('Failed to load document');
				}
			}
		};

		getContents();
	}, []);

	return (
		<DocumentPortal width={600} height={600}>
			<iframe title="document-portal" width="100%" height="100%" style={{ border: '0px' }} src={`${data != null ? (data as any).location : ''}`}></iframe>
		</DocumentPortal>
	);
};
